module.exports = __webpack_public_path__ + "static/media/icon-supplies-makeupremover.6de10a7b.svg";